import { baseUrl } from "./baseUrl";

// eslint-disable-next-line import/prefer-default-export
export const tenantsRoute = () => [`${baseUrl}`, "dict-api", "tenants"].join("/");

export const tenantsIdRoute = (id) => [`${baseUrl}`, "dict-api", "tenants", `${id}`].join("/");
